import React from 'react'

const PlanningPokerPrivacyPolicy = () => (
    <div className="container mt-3">
        <div className="row">		
          <div className="col-md-12 col-xs-12 card card-body description text-justify p-4">
            <h2 className="h2-title pb-4 pt-4">Privacy Policy</h2>
            <p>This Privacy Policy describes the information collected by Igrecway through the Igrecway Planning Poker mobile application.</p>

            <p> We do not ask for or collect personally identifiable information such as names or email addresses about the users of our mobile applications. We do not include any social network integration, or third party advertising.</p>

            <p> Note that our application uses third-party service Firebase crash reporting solution. This Service automatically collects certain non-personally identifiable information relating to application crashes from End Users, including, without limitation, device state information at the time of a crash, unique device identifiers and information relating to the physical location of a device at the time of a crash.</p>

            <p>This information is collected in order for us to make improvements.</p>

            <p>If you have any questions about our Privacy Policy please contact us at: <a href="mailto:igrecway@gmail.com">igrecway@gmail.com</a></p>
        </div>
    </div>
  </div>		
)

export default PlanningPokerPrivacyPolicy


// WEBPACK FOOTER //
// ./src/planning-poker-privacy-policy/privacy-policy.js